import styled from 'styled-components'

export const SparklineRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 1.125rem;
  border: 1px solid ${({ theme }) => theme.grey400Color};
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.whiteColor};
`

export const SparklineLabel = styled.span`
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.grey900Color};
`

export const ChartArea = styled.div`
  position: relative;
`

export const SparklineSvg = styled.svg`
  display: block;
  width: 100%;
  height: 4.5rem;
  overflow: visible;
`

export const EmptyCaption = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 0.6rem));
  font-size: 0.8125rem;
  font-weight: 500;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.grey700Color};
  white-space: nowrap;
`

export const Marker = styled.div<{ $colour?: string; $filled?: boolean }>`
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  background: ${({ $filled, $colour, theme }) =>
    $filled ? $colour ?? theme.successColor : theme.whiteColor};
  border: 2px solid ${({ $colour, theme }) => $colour ?? theme.successColor};
`

export const XAxisRow = styled.div`
  position: relative;
  height: 1.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.3px;
`

export const XAxisLabel = styled.span<{ $dimmed?: boolean }>`
  position: absolute;
  transform: translateX(-50%);
  white-space: nowrap;
  color: ${({ $dimmed, theme }) => ($dimmed ? theme.grey400Color : theme.grey700Color)};
`

export const SparklineHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const SparklineValue = styled.span`
  align-self: flex-end;
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 400;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.grey900Color};
`
